<mat-toolbar color="primary" class="custom-primary customer">
  <div class="center-content">
    <span>
      <img class="logo" src="assets/images/logo.png" alt="" />
    </span>
  </div>
</mat-toolbar>
<div class="container">
  <mat-card class="mat-elevation-z6" style="width: 1000px">
    <mat-card-header style="text-align: center">
      <mat-card-title>
        <span> Faça o cadastro da sua empresa </span>
      </mat-card-title>
    </mat-card-header>

    <ng-container *ngIf="continueRegister">
      <p class="helper">
        Por favor, verifique se as suas informações estão corretas!
      </p>
    </ng-container>

    <ng-container *ngIf="!(isSmallScreen$ | async); else mobileSteps">
      <mat-vertical-stepper [linear]="isLinearSteep" #stepper>
        <mat-step label="Informações da empresa" [stepControl]="stepOne">
          <app-step-company-basic-info
            (formObserver)="onStepOne($event)"
            [initData]="continueDataEvent"
            (hiddenCheckout)="onHiddenCheckout($event)"
            (submited)="stepsValid[0] = true"
          ></app-step-company-basic-info>
        </mat-step>
        <mat-step label="Informações de acesso" [stepControl]="stepTwo">
          <app-step-company-contact
            (formObserver)="onStepTwo($event)"
            [initData]="continueDataEvent"
            (submited)="submitStepTwo()"
          ></app-step-company-contact>
        </mat-step>
        <ng-container *ngIf="!hiddenCheckout">
          <mat-step label="Escolha seu plano">
            <app-finish-company
              (submit)="handleFinishSubmit($event)"
              [isFree]="isFree"
            ></app-finish-company>
          </mat-step>
        </ng-container>
      </mat-vertical-stepper>
    </ng-container>

    <ng-template #mobileSteps>
      <mat-horizontal-stepper [linear]="isLinearSteep" #stepper>
        <mat-step [stepControl]="stepOne">
          <app-step-company-basic-info
            (formObserver)="onStepOne($event)"
            [initData]="continueDataEvent"
            (hiddenCheckout)="onHiddenCheckout($event)"
            (submited)="stepsValid[0] = true"
          ></app-step-company-basic-info>
        </mat-step>
        <mat-step [stepControl]="stepTwo">
          <app-step-company-contact
            (formObserver)="onStepTwo($event)"
            [initData]="continueDataEvent"
            (submited)="submitStepTwo()"
          ></app-step-company-contact>
        </mat-step>
        <ng-container *ngIf="!hiddenCheckout">
          <mat-step label="Escolha seu plano">
            <app-finish-company
              (submit)="handleFinishSubmit($event)"
              [isFree]="isFree"
            ></app-finish-company>
          </mat-step>
        </ng-container>
      </mat-horizontal-stepper>
    </ng-template>

    <!-- <div class="actions">
            <button class="custom-primary" mat-raised-button (click)="doneAll()"
                [disabled]="!isComplete()">Concluir</button>
        </div> -->
  </mat-card>
</div>
